export const STORE_BASIC_EVENT_SETTINGS = 'basicEventSettingsStore';
export const BES_SET_OPTIONS = 'setOptions';
export const BES_SET_SETTING = 'setSetting';
export const BES_SAVE_DATA = 'saveData';
